<template>
  <v-row no-gutters>
    <template v-for="(groupAddons, index) in datas" cols="12">
      <AddonSimpleSubcomponent
        v-if="
          groupAddons.mainAddon[0].minSelection > 0 &&
          groupAddons.mainAddon[0].maxSelection === 1
        "
        :key="index"
        v-model="addonSimple[index]"
        :title="groupAddons.description"
        :datas="groupAddons.mainAddon[0].subAddons"
      />
      <AddonMultiplecomponent
        v-else
        :key="index"
        v-model="addonSimple[index]"
        :title="groupAddons.mainAddon[0].name"
        :datas="groupAddons.mainAddon[0].subAddons"
        :max="groupAddons.mainAddon[0].maxSelection"
        :min="groupAddons.mainAddon[0].minSelection"
      />
    </template>
  </v-row>
</template>

<script>
import {
  AddonSimpleSubcomponent,
  AddonMultiplecomponent,
} from "./subcomponents";
export default {
  name: "AddonsComponent",
  components: {
    AddonSimpleSubcomponent,
    AddonMultiplecomponent,
  },
  props: {
    datas: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    addonSimple: [],
    completeArray: [],
    total: 0,
  }),
  watch: {
    addonSimple: function () {
      this.generateArray();
    },
  },
  methods: {
    generateArray: function () {
      const self = this;
      self.completeArray = [];

      for (let index = 0; index < self.addonSimple.length; index++) {
        if (self.addonSimple[index]) {
          if (self.addonSimple[index].length > 0) {
            for (let x = 0; x < self.addonSimple[index].length; x++) {
              self.completeArray.push(self.addonSimple[index][x]);
            }
          } else {
            if (!Array.isArray(self.addonSimple[index])) {
              self.completeArray.push(self.addonSimple[index]);
            }
          }
        } else {
          break;
        }
      }

      self.$emit("input", self.completeArray);
    },
  },
};
</script>
